import React, { Component } from 'react';


class FilterCheckBox extends Component {
  render () {
    return (
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          checked={this.props.isActive}
          />
        <label className="filter-category" onClick={this.props.handleToggle}>
          {this.props.title} {this.props.icon ? (<img src={this.props.icon} alt={this.props.title} className="filter-icon" />) : ''}
        </label>
      </div>
    )
  }
}

export default FilterCheckBox;



// WEBPACK FOOTER //
// ./src/Components/FilterCheckBox.js